'use client';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Power, Ellipsis, CalendarClock, Bot, TvMinimalPlay, Monitor } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import './style/index.css';
interface InviteLiveProps {
  isLive?: boolean;
  isStreamer?: boolean;
}
const InviteLive: React.FC<InviteLiveProps> = ({ isLive, isStreamer }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  if (isStreamer) {
    return (
      <div
        className={cn(
          'relative flex items-center rounded-lg h-8 border overflow-hidden py-[0.5px] px-[1px]',
          isLive ? ' border-orange-500' : 'border-primary/60'
        )}
      >
        {isLive ? (
          <div
            className="flex items-center justify-center text-orange-500 text-sm px-3 text-medium gap-1 transition-all duration-200 cursor-pointer hover:bg-orange-500 hover:text-black group rounded-tl-md rounded-bl-md h-7 relative pl-4 group"
            onClick={() => {
              navigate('/stream/start');
            }}
            title={t('invite.isLive')}
          >
            <div className="co-live-banner-icon !w-4 !mr-0 !mt-0.5 !h-3 !text-orange-500 group-hover:!text-black">
              <span></span>
            </div>
            <span className="max-xl:hidden">{t('invite.isLive')}</span>
            <div className="absolute top-0 left-0 z-10 bg-orange-500 text-white p-0.5 px-1 rounded-br-md rounded-tl-md group-hover:bg-white group-hover:text-orange-500">
              <Monitor className="size-2" fill="currentColor" />
            </div>
          </div>
        ) : (
          <div
            className="h-7 flex items-center justify-center text-primary-500 text-sm px-3 text-medium gap-1 hover:bg-primary hover:text-font-reverse transition-all duration-200 cursor-pointer rounded-tl-md rounded-bl-md"
            onClick={() => {
              navigate('/stream/start');
            }}
            title={t('invite.startLiveNow')}
          >
            <Power className="w-4 h-4" />
            <span className="max-xl:hidden">{t('invite.startLiveNow')}</span>
          </div>
        )}

        <div className="w-[0.5px] h-4 bg-primary/30 -mx-0.5"></div>
        <div
          className="h-7 flex items-center justify-center text-primary-500 text-sm px-3 text-medium gap-1 hover:bg-primary hover:text-font-reverse transition-all duration-200 cursor-pointer"
          onClick={() => {
            navigate('/stream/reserve');
          }}
          title={t('invite.scheduleLiveBroadcast')}
        >
          <CalendarClock className="w-4 h-4" />
          <span className="max-xl:hidden">{t('invite.scheduleLiveBroadcast')}</span>
        </div>
        <div className="w-[0.5px] h-4 bg-primary/30 -mx-0.5"></div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="h-7 flex items-center justify-center text-primary-500 text-sm px-2 text-medium gap-1 hover:bg-primary hover:text-font-reverse transition-all duration-200 cursor-pointer rounded-tr-md rounded-br-md">
              <Ellipsis className="w-4 h-4" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" sideOffset={10} className="p-2 relative group min-w-[180px]">
            <DropdownMenuItem
              className="py-1 focus:bg-background-3/10 focus:text-font-primary flex items-center justify-between"
              onClick={() => {
                navigate('/stream/appointment');
              }}
            >
              <div className="flex items-center gap-2">
                <div className="flex items-center mr-1 bg-secondary-hover p-2 rounded-lg">
                  <TvMinimalPlay className="h-4 w-4" />
                </div>
                <span>{t('invite.reserveManage')}</span>
              </div>
            </DropdownMenuItem>
            {process.env.isProd ? null : (
              <DropdownMenuItem
                className="py-1 focus:bg-background-3/10 focus:text-font-primary flex items-center justify-between"
                onClick={() => {
                  navigate('/stream/helper');
                }}
              >
                <div className="flex items-center gap-2 break-all">
                  <div className="flex items-center mr-1 bg-secondary-hover p-2 rounded-lg">
                    <Bot className="h-4 w-4" />
                  </div>
                  <span>{t('invite.liveAssistantTool')}</span>
                </div>
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  }
  return (
    <div className="actButton-main actButton-blue" onClick={() => navigate('/me/form')}>
      <TvMinimalPlay className="w-4 h-4" />
      {t('invite.applyToBeStreamer')}
    </div>
  );
};

export default InviteLive;
